import { render, staticRenderFns } from "./Feedbackform.vue?vue&type=template&id=935a577a&scoped=true&"
import script from "./Feedbackform.vue?vue&type=script&lang=js&"
export * from "./Feedbackform.vue?vue&type=script&lang=js&"
import style0 from "./Feedbackform.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Feedbackform.vue?vue&type=style&index=1&id=935a577a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935a577a",
  null
  
)

export default component.exports